import React,{ useState , useEffect, useCallback, useRef} from 'react';
import * as ReactDOM from 'react-dom';
import SubHeader from '../components/SubHeader';
import config from '../appconfig/config.json';
import headerImg from '../hybridImages/PStepper3.png'; 
import FormContainer from '../components/FormContainer';
import { Field, FieldWrapper, Form, FormElement } from '@progress/kendo-react-form';
import { CusFormCalenInput, CusFormComboBox, CusFormDateInput, CusFormInput, CusFormNumericTextBox, FormComboBox , FormInput, FormNumericTextBox, FormTitleHybrid, FormTitleTooltip  } from '../validation/Form-Components';
import pData from '../hybriddata/propertydata.json';
import CusRadioG2Btn from '../hybridcomponents/CusRadioG2Btn';
import { allowZeroNumericValidator, decimalValidator, leaseholdDateValidator, numericValidator, postalCodeValidator, reqDDLValidator, requiredValidator, zeroDecimalValidator } from '../validation/Validators';
import CusRadioButton from '../components/CusRadioButton';
import LocalAddress from '../hybridcomponents/LocalAddress';
import addService from '../services/ApiService';
import LoadingText from '../components/LoadingText';
import Loading from '../components/Loading';
import { useHistory } from "react-router-dom";
import helper from '../factory/Helper';
import storage from '../factory/StorageFactory';
import ForeignAddress from '../hybridcomponents/ForeignAddress';
import service from '../services/PropertyDtlsApiService';
import CusToast from '../components/CusToast';
import { Button } from '@progress/kendo-react-buttons';
import { pdf } from '@progress/kendo-drawing';
import AddBankBalncePopup from '../hybridcomponents/AddBankBalancePopup';
import BankBalanceHistory from '../hybridcomponents/BankBalanceHistory';
import bblistEg from '../hybriddata/bankBalanceListSample.json'
import { NumericTextBox } from '@progress/kendo-react-inputs';
import { ComboBox } from '@progress/kendo-react-dropdowns';
import currencies from '../hybriddata/currencyList.json';
import pTypes from '../hybriddata/propertyTypes.json';
import { filterBy } from "@progress/kendo-data-query";
import AddCommitmentPopup from '../hybridcomponents/AddCommitmentPopup';
import CommitmentHistory from '../hybridcomponents/CommitmentHistory';

const PropertyDetailsAIP = (props) => {
      
    let timer; 
    const history = useHistory();
 
    const todayDate = new Date();

    const addressTag='sg', defSgDesc = 'SINGAPORE';
    const numericRegex = new RegExp(/^[0-9]+$/);

    const [isLoading,setIsLoading] = useState(false);
    const [isSearching,setIsSearching] = useState(false);
    const [isSaving,setIsSaving] = useState(false);

    const [isError,setIsError] = useState(false);
    const [errMsg, setErrMsg] = useState('');

    const [response,setResponse] = useState();

    //currency 
    const [latestAnnIntDepOrAmortCurrencies, setLatestAnnIntDepOrAmortCurrencies] = useState(currencies.slice());
    const [latestAnnIntExpCurrencies, setLatestAnnIntExpCurrencies] = useState(currencies.slice());

    //to determine pure AIP or not, Y - show leasehold & MB Acct Dtls sections
    //N - hide leasehold & MB Acct Dtls sections 
    const [isPureAIP,setIsPureAIP] = useState(false); 

    const [selectedRdoTypeOfFinancing,setSelectedRdoTypeOfFinancing] = useState(null);
    const [selectedRdoPurpose,setSelectedRdoPurpose] = useState(null);
    const [selectedRdoPropertyInMind, setSelectedRdoPropertyInMind] = useState(null);
    const [selectedRdoIsLeasehold, setSelectedRdoIsLeasehold] = useState(null);
    const [selectedRdoHasMaybankAcct, setSelectedRdoHasMaybankAcct] = useState(null);
    const [selectedRdoHasOthBankAcct, setSelectedRdoHasOthBankAcct] = useState(null);//CR
    const [origLeaseHoldValue, setOrigLeaseHoldValue] = useState(null);
    const [leaseHoldEffDateInputValue,setLeaseHoldEffDateInputValue] = useState(null);
    //bank balance
    const [addBankBalancePopup,setAddBankBalancePopup] = useState(false);
     
    const [bankBalanceList, setBankBalanceList] = useState([])
    const [bankBalanceItem,setBankBalanceItem] = useState(null);
    const [lastSixMonthsArray, setLastSixMonthsArray] = useState([]);
    const [bankBalIndex, setBankBalIndex] = useState(0);

    const [sgAddTypeResult,setSgAddTypeResult] = useState(null);

    //monthly debt commitments
    const [addCommitmentPopup,setAddCommitmentPopup] = useState(false);
    // const [monthlyDebtCommitList, setMonthlyDebtCommitList] = useState([{ddlLoanProdType:null,ddlNoOfBank:null,amount:null}])
    const [monthlyDebtCommitList, setMonthlyDebtCommitList] = useState([]);
    const [monthlyDebtCommitItem,setMonthlyDebtCommitItem] = useState(null);
    const [mdcIndex, setMdcIndex] = useState(0);

    const [initFormData,setInitFormData] = useState({
        latestOutLoanAmtValue:null,
        propertyTypeCbo:null,  // existing 
        purchasePriceValue:null, //numeric,
        leaseHoldEffDate:new Date(2022, 1, 20), //date dd/MM/yyyy
        originalLeaseHoldCbo:null, // new
        origLeaseHoldOth:'', //new if originalLeaseHoldCbo is Oth

        sgPostalCode: "", // existing 
        sgBlkNo: "", // existing 
        sgStreet: "", // existing 
        sgStoreyNo: "", // existing 
        sgUnitNo: "", // existing 
        sgBuilding: "", // existing 
        sgLockedBagNo: "", // existing 
        sgGodownNo: "",  // existing 
        sgLotMukimNo:"", // existing 
        sgBoxNo: "", // existing 
        sgPostOffice: "", // existing 
        sgHouseNo: "", // existing 
        sgWindowDeliveryNo: "",// existing 

        city:'', // existing 
        state:'',// existing 
        postal_Code:'',// existing 

        latestAnnIntExpCurrencyCbo:{"value":"SGD","label":"SGD"},//new default to SGD
        latestAnnIntExp:null, //numeric new 

        latestAnnIntDepOrAmortCurrencyCbo:{"value":"SGD","label":"SGD"}, //new default to SGD
        latestAnnIntDepOrAmort:null
    })

    const handleOnWheel = event => {
        event.stopPropagation();
    };
    

    useEffect(() => {
        console.log('@PropertyDetails useEffect');
      
 
        if(helper.isTokenExpired()) {
            props.history.push(config.route.SessionExpired);
            return;
        }
  
        window.scrollTo(0,0);

    
        if(storage.getIsPureAIP() === 'true') {
            setIsPureAIP(true); //default 
        }
        else {
            setIsPureAIP(false); //default
        }
  
        getData();
        return () => {
            clearTimeout(timer);
             
        }
    }, []);

 
    const getData = () => {
        setIsLoading(true);
        const rno = storage.getRefNo();
        // console.log('getData',rno);
        service.get(rno).then( res => {
            if(res.data.isSucess) {
                const resData = res.data.model;
                setLastSixMonthsArray(getLastSixMonths());
                setResponse(resData);
                if(resData.typeOfFinance !== '' && resData.typeOfFinance !== null){ 
                    bindFormData(resData);
                }
                setIsLoading(false);
            }
            else{
                setIsLoading(false);
                showErrMsg(config.error.GetApiFailed);
            }
        })
        .catch(err=>{
            console.log('err: ',err);
            setIsLoading(false);
            showErrMsg(config.error.GetApiFailed);
            return;
        })
    }

    const bindFormData = (data) => {
        try{
            setIsPureAIP(true);
            let purposeValue = null, propInMindValue = null,propertyTypeCboValue = null;
            let latestOutLoanAmtValue=null, purPriceValue = null;
    
            let leaseHoldRdoValue = null, leaseHoldEffDateValue=null, origLeaseHoldCboValue = null,origLeaseHoldOthValue='';
    
            let hasMaybankAcctRdoValue =null, hasOthBankAcctRdoValue=null;
    
            let latestAnnIntExpCurrencyCboValue = {"value":"SGD","label":"SGD"},latestAnnIntExpValue = null;
            let latestAnnIntDepOrAmortCurrencyCboValue= {"value":"SGD","label":"SGD"}, latestAnnIntDepOrAmortAmtValue=null;
    
            const typeOfFinanceValue = (data.typeOfFinance !=='')?data.typeOfFinance:null;
         
            if(typeOfFinanceValue === pData.typeOfFinanceRdo.firstValue) { //New Purchase
                purposeValue = (data.purpose !=='')?data.purpose:null;
                propInMindValue = (data.propertyInMind !=='')?data.propertyInMind:null;
                setIsPureAIP(true);
                if(purposeValue === pData.purposePropertyRdo.firstValue) { //Biz Ops
                    hasMaybankAcctRdoValue = (data.isSixMonthsBankBalWithMaybank !=='' && data.isSixMonthsBankBalWithMaybank !==null)?data.isSixMonthsBankBalWithMaybank:null;
                    hasOthBankAcctRdoValue = (data.isActiveBizAcctWithOtherBanks !=='' && data.isActiveBizAcctWithOtherBanks !==null)?data.isActiveBizAcctWithOtherBanks:null;
                    setIsPureAIP(true);
                }
                else { //rental income /invest
                    setIsPureAIP(false);
                }
    
              
                bindBankBalanceList(data.bankBalanceDetails)
                bindMontlyDebtCommitments(data.monthlyDebtCommitments);
                
                latestAnnIntExpValue = (data.latestAnnualIntrestExpense !=='' && data.latestAnnualIntrestExpense !==null)?parseFloat(data.latestAnnualIntrestExpense):null;
                if(data.latestAnnualIntrestExpenseCurrency !== '' && data.latestAnnualIntrestExpenseCurrency !== null) {
                    const fObj ={
                        value: data.latestAnnualIntrestExpenseCurrency,
                        label:data.latestAnnualIntrestExpenseCurrency
                    }
                    latestAnnIntExpCurrencyCboValue = fObj;
                }

                latestAnnIntDepOrAmortAmtValue = (data.latestAnnualDepreciationOrAmortisationAmt !=='' &&data.latestAnnualDepreciationOrAmortisationAmt !==null)?parseFloat(data.latestAnnualDepreciationOrAmortisationAmt):null;
                if(data.latestAnnualDepreciationOrAmortisationAmtCurrency !=='' && data.latestAnnualDepreciationOrAmortisationAmtCurrency !==null){
                    const fObj ={
                        value: data.latestAnnualDepreciationOrAmortisationAmtCurrency,
                        label:data.latestAnnualDepreciationOrAmortisationAmtCurrency
                    }
                    latestAnnIntDepOrAmortCurrencyCboValue = fObj;
                }
    
    
                if(propInMindValue === 'Y') {
                    propertyTypeCboValue = {value:data.propertyType,label: data.propertyTypeDescription};
                    if(data.propertyType === pData.propTypeShopCode) {
                        setIsPureAIP(false);
                    }
                    purPriceValue = (data.purchasePrice !== '' && data.purchasePrice !== null)?parseFloat(data.purchasePrice):null;
                    if(data.isLeaseHold !== '' && data.isLeaseHold !==null) {
                    
                        leaseHoldRdoValue = data.isLeaseHold;
                        leaseHoldEffDateValue = (data.leaseHoldEffDate !=='' && data.leaseHoldEffDate !==null)?new Date(data.leaseHoldEffDate):null;
                      
                        origLeaseHoldCboValue = (data.originalLeaseHold !==''&& data.originalLeaseHold !==null)?helper.getObjInArray(data.originalLeaseHold,pData.origLeaseHoldDDLList):null;
                        setOrigLeaseHoldValue(origLeaseHoldCboValue);
                        // console.log('leaseHoldEffDateValue',leaseHoldEffDateValue)
                        setLeaseHoldEffDateInputValue(leaseHoldEffDateValue)
                        origLeaseHoldOthValue = data.originalLeaseHold ==='Others'?data.originalLeaseHoldOthers:'';
                    }
                }
            }
            else { //Refinance
                setIsPureAIP(false);
                latestOutLoanAmtValue = (data.latestOutstandingLoanAmt !== '' && data.latestOutstandingLoanAmt !==null)?parseFloat(data.latestOutstandingLoanAmt):null;
            }
       
            setSelectedRdoTypeOfFinancing(typeOfFinanceValue);
            setSelectedRdoPurpose(purposeValue);
            setSelectedRdoPropertyInMind(propInMindValue);
            setSelectedRdoIsLeasehold(leaseHoldRdoValue);
            setSgAddTypeResult(data.addressType !==''?data.addressType:null);
            setSelectedRdoHasMaybankAcct(hasMaybankAcctRdoValue);
            setSelectedRdoHasOthBankAcct(hasOthBankAcctRdoValue);
        
            setInitFormData({
                latestOutLoanAmtValue:latestOutLoanAmtValue,
    
                propertyTypeCbo:propertyTypeCboValue,  // existing 
                purchasePriceValue:purPriceValue, //numeric,
    
                leaseHoldEffDate: leaseHoldEffDateValue, //date dd/MM/yyyy
                originalLeaseHoldCbo:origLeaseHoldCboValue, // new
                origLeaseHoldOth:origLeaseHoldOthValue, //new if originalLeaseHoldCbo is Oth
               
                sgPostalCode: data.postal_Code, // existing 
                sgBlkNo: data.block_Number, // existing 
                sgStreet: data.street_Name, // existing 
                sgStoreyNo: data.storey_Number, // existing 
                sgUnitNo: data.unit_Number, // existing 
                sgBuilding: data.building_Name, // existing 
                sgLockedBagNo: data.locked_Bag_Number, // existing 
                sgGodownNo: data.godown_Number,  // existing 
                sgLotMukimNo:data.lot_Mukim_Number, // existing 
                sgBoxNo: data.box_Number, // existing 
                sgPostOffice: data.post_Office_Name, // existing 
                sgHouseNo: data.house_Number, // existing 
                sgWindowDeliveryNo: data.window_Delivery_Number,// existing 
        
                city:data.city, // existing 
                state:data.state,// existing 
         
                latestAnnIntExpCurrencyCbo:latestAnnIntExpCurrencyCboValue,//new default to SGD
                latestAnnIntExp:latestAnnIntExpValue, //numeric new 
        
                latestAnnIntDepOrAmortCurrencyCbo:latestAnnIntDepOrAmortCurrencyCboValue, //new default to SGD
                latestAnnIntDepOrAmort:latestAnnIntDepOrAmortAmtValue
            })

        }catch(e){
            
        }
       
    }

    //RADIO BUTTON SECTION
    const handleTypeOfFinanceRdoChange = (e) => {
        
        try{
            setSelectedRdoTypeOfFinancing(e.value);
            if(e.value === pData.typeOfFinanceRdo.secValue){ //Refinancing
                setIsPureAIP(false);
                setSgAddTypeResult(null);
                setSelectedRdoPurpose(null);
                setSelectedRdoPropertyInMind(null);
                setSelectedRdoIsLeasehold(null);
                setSelectedRdoHasMaybankAcct(null);
                resetFormFields();
            }
            else { //new purchase
                setIsPureAIP(true);
            }
        }
        catch(e){

        }
 
    }

    const handleRdoGroupPurposeChange = (e, selectedPropTypeValue) => {
        setSelectedRdoPurpose(e.value);

        if(e.value === pData.purposePropertyRdo.secValue){ //Hybrid
            // console.log('handleRdoGroupPurposeChange hybrid',e.value)
            setIsPureAIP(false); //not pure AIP, Hybrid
        }
        else { // Pure AIP
            if(selectedRdoPropertyInMind === 'N') { //no prop, def PureAIP
                setIsPureAIP(true); 
            }
            else if((selectedRdoPropertyInMind === 'Y') && selectedPropTypeValue === pData.propTypeShopCode){  
                setIsPureAIP(false); 
            }
            else {
                setIsPureAIP(true); 
            }
        }
    }

    const handlePropertyTypeCboChange = (e) => {
 
        if(e.value !== null) {
            if(e.value.value === pData.propTypeShopCode) {
                setIsPureAIP(false);
            }
            else {
                if(selectedRdoPurpose === pData.purposePropertyRdo.secValue) {
                    setIsPureAIP(false);
                }
                else{
                    setIsPureAIP(true);
                }
            }
        }
    }

    const handleRdoIsLeaseholdChange = (e)=> {
        setSelectedRdoIsLeasehold(e.value);
    }

    const handleRdoHasMaybankAcctChange = (e) => {
        setSelectedRdoHasMaybankAcct(e.value);
    }

    const handleRdoHasOthBankAcctChange = (e) => {
        setSelectedRdoHasOthBankAcct(e.value);
    }

    const handleOriginalLeaseHoldChange = (e)=> {
        // console.log('handleOriginalLeaseHoldChange',e.value);
        setOrigLeaseHoldValue(e.value);
    }

    const handleSubmit = (dataItem) => {
        // console.log('@handleSubmit ',dataItem);
        if(dataItem.isValid) {
            let data = JSON.parse(JSON.stringify(dataItem.values));
            // console.log('@handleSubmit ',isPureAIP);
            storage.setIsAIPSubmission(isPureAIP?'Y':'N')
       
            if(!isValidRdoFields()) {
                //DO NTH
                return;
            }

            //VALID
            const params = formatJsonParams(data);
            // console.log('formatJsonParams: ',params);
            savePropertyDetails(params);
        }
        else {
            showErrMsg(pData.error.inputFields);
        }
    }

    const savePropertyDetails = (params) => {
 
        setIsSaving(true);
        service.post(params).then(res => {    
            setIsSaving(false);
            if(res.data.isSucess) {
                goNext();
            }  
            else {
                showErrMsg(config.error.SaveApiFailed);
            } 
        }).catch(err => {
            console.log('err: ',err);
            setIsSaving(false);
            showErrMsg(config.error.SaveApiFailed);
        })
    }
  
    let formatJsonParams = function(data) {

        let typeOfFinCode= '',typeOfFinDesc='';
        let purposeCode='',purposeDesc = '';
        let latestOutLoanAmt= null;
        let propInMindCode = '',propInMindDesc='';
        let propType = '',propTypeDesc='';
        let purPrice = null;
        let isLeaseholdCode = '',isLeaseholdDesc='';
        let leaseHoldEffDateValue=null, origLeaseHoldCode='', origLeaseHoldDesc='',origLeaseHoldOth='';
        let postalCode = '',addType='';

        let isSixMonthsBankBalWithMaybankCode = '', isSixMonthsBankBalWithMaybankDesc = '';
        let isActiveBizAcctWithOtherBanksCode = '', isActiveBizAcctWithOtherBanksDesc = '';

        let bankBalDtlsArray = [],monthlyDebtCommitArray = [];
        let latestAnnIntExpCCY='',latestAnnIntExpAmt=null;
        let latestAnnIntDepOrAmortCCY='',latestAnnIntDepOrAmortAmt=null;
        let isRefinance=false;

        postalCode = data.sgPostalCode;
        addType = sgAddTypeResult;

        if(selectedRdoTypeOfFinancing !== null){
            if(selectedRdoTypeOfFinancing === pData.typeOfFinanceRdo.firstValue){ //NEW PURCHASE
                typeOfFinCode = pData.typeOfFinanceRdo.firstValue;
                typeOfFinDesc = pData.typeOfFinanceRdo.firstValueLbl;
            }
            else { //REFINANCE
                typeOfFinCode = pData.typeOfFinanceRdo.secValue;
                typeOfFinDesc = pData.typeOfFinanceRdo.secValueLbl;
                latestOutLoanAmt = data.latestOutLoanAmtValue;
                isRefinance = true;
            }
        }

        if(selectedRdoPurpose !== null) {
            if(selectedRdoPurpose === pData.purposePropertyRdo.firstValue){ //IS BIZ OPER
                purposeCode = pData.purposePropertyRdo.firstValue; 
                purposeDesc = pData.purposePropertyRdo.firstValueLbl;
            
            }
            else {//RENT AND INVESTMENT
                purposeCode = pData.purposePropertyRdo.secValue;
                purposeDesc = pData.purposePropertyRdo.secValueLbl;
            
            }
        }

        if(selectedRdoPropertyInMind !== null) {
            if(selectedRdoPropertyInMind === pData.propertyInMindRdo.leftValue){ //Y
                propInMindCode = pData.propertyInMindRdo.leftValue;
                propInMindDesc = pData.propertyInMindRdo.leftValueLbl;
                propType = data.propertyTypeCbo !==null ? data.propertyTypeCbo.value:'';
                propTypeDesc =  data.propertyTypeCbo !==null ? data.propertyTypeCbo.label:'';
                purPrice = data.purchasePriceValue !==null? data.purchasePriceValue.toFixed(2):null;
            }
            else { //N
                propInMindCode = pData.propertyInMindRdo.rightValue;
                propInMindDesc = pData.propertyInMindRdo.rightValueLbl;
                propType = '';
                propTypeDesc = '';
                purPrice = null;
                addType = null;
            }
        }
 
        if(isPureAIP &&  selectedRdoIsLeasehold !== null) {
            if(selectedRdoIsLeasehold === pData.isLeaseholdRdo.leftValue) { //Y
                isLeaseholdCode = pData.isLeaseholdRdo.leftValue;
                isLeaseholdDesc = pData.isLeaseholdRdo.leftValueLbl;
                leaseHoldEffDateValue = data.leaseHoldEffDate!==null? helper.formatDateYYYYMMDD(data.leaseHoldEffDate):null;
                origLeaseHoldCode = data.originalLeaseHoldCbo !== null? data.originalLeaseHoldCbo.value:'';
                origLeaseHoldDesc = data.originalLeaseHoldCbo !== null? data.originalLeaseHoldCbo.label:'';
                if(data.originalLeaseHoldCbo !== null && data.originalLeaseHoldCbo.value == 'Others') {
                    origLeaseHoldOth = data.origLeaseHoldOth;
                }
            }
            else {//N
                isLeaseholdCode = pData.isLeaseholdRdo.rightValue;
                isLeaseholdDesc = pData.isLeaseholdRdo.rightValueLbl;
                leaseHoldEffDateValue = null;
                origLeaseHoldCode = '';
                origLeaseHoldDesc = '';
                origLeaseHoldOth = '';
            }
        }

        if(isPureAIP && selectedRdoHasMaybankAcct !== null) {
            if(selectedRdoHasMaybankAcct === pData.hasMaybankAcctRdo.leftValue) {  //Y
                isSixMonthsBankBalWithMaybankCode = pData.hasMaybankAcctRdo.leftValue;
                isSixMonthsBankBalWithMaybankDesc = pData.hasMaybankAcctRdo.leftValueLbl;
            }
            else { //N
                isSixMonthsBankBalWithMaybankCode = pData.hasMaybankAcctRdo.rightValue;
                isSixMonthsBankBalWithMaybankDesc = pData.hasMaybankAcctRdo.rightValueLbl;
            }
        }

        if(isPureAIP && selectedRdoHasOthBankAcct !== null) {
            if(selectedRdoHasOthBankAcct === pData.hasOthBankAcctRdo.leftValue) {  //Y
                isActiveBizAcctWithOtherBanksCode = pData.hasOthBankAcctRdo.leftValue;
                isActiveBizAcctWithOtherBanksDesc = pData.hasOthBankAcctRdo.leftValueLbl;
            }
            else { //N
                isActiveBizAcctWithOtherBanksCode = pData.hasOthBankAcctRdo.rightValue;
                isActiveBizAcctWithOtherBanksDesc = pData.hasOthBankAcctRdo.rightValueLbl;
            }
        }

        if(isPureAIP) {
            bankBalDtlsArray = formatBankBalanceList();
            monthlyDebtCommitArray = formatMonthlyDebtCommitList();
    
            latestAnnIntExpCCY= data.latestAnnIntExpCurrencyCbo !==null? data.latestAnnIntExpCurrencyCbo.value:'';
            latestAnnIntExpAmt = data.latestAnnIntExp !==null?data.latestAnnIntExp.toFixed(2):null;
    
            latestAnnIntDepOrAmortCCY = data.latestAnnIntDepOrAmortCurrencyCbo !==null? data.latestAnnIntDepOrAmortCurrencyCbo.value:'';
            latestAnnIntDepOrAmortAmt = data.latestAnnIntDepOrAmort !== null?data.latestAnnIntDepOrAmort.toFixed(2):null;
        }
  
        let params = {
            // stateId:storage.getStateId(),
            referenceNo: storage.getRefNo(),
            typeOfFinance: typeOfFinCode,
            typeOfFinanceDescription: typeOfFinDesc,
            latestOutstandingLoanAmt:latestOutLoanAmt,
            purpose:purposeCode, //existing
            purposeDescription:purposeDesc, //existing
            propertyInMind: propInMindCode,
            propertyInMindDescription: propInMindDesc,
            propertyType: propType, //existing
            propertyTypeDescription: data.propertyTypeCbo !==null ? data.propertyTypeCbo.label:'', //existing
            purchasePrice:purPrice, //existing
            isLeaseHold: isLeaseholdCode,
            isLeaseHoldDescription: isLeaseholdDesc,
            leaseHoldEffDate:leaseHoldEffDateValue,
            originalLeaseHold: origLeaseHoldCode,
            originalLeaseHoldDescription: origLeaseHoldDesc,
            originalLeaseHoldOthers: origLeaseHoldOth,
             
            builtInArea: '' , //remove
            builtInAreaType: '' , //remove
            builtInAreaTypeDescription: '', //remove
            propertyStatus:'', //remove
            propertyStatusDescription:'', //remove
            refinance:'', //remove
            refinanceDescription:'', //remove
   
            propertyAddress:'', //remove
            propertyAddressDescription:'', //remove

            country: 'SG', //existing, default will pass 'SG'

            postal_Code: (isRefinance || propInMindCode === 'Y')? postalCode:'',  //existing
            addressType:  (isRefinance || propInMindCode === 'Y')? addType:'', //existing

            block_Number:  (isRefinance || propInMindCode === 'Y')? data.sgBlkNo:'', //existing
            street_Name:  (isRefinance || propInMindCode === 'Y')? data.sgStreet:'',//existing
            storey_Number:  (isRefinance || propInMindCode === 'Y')? data.sgStoreyNo:'',//existing
            unit_Number:  (isRefinance || propInMindCode === 'Y')? data.sgUnitNo:'',//existing
            building_Name: (isRefinance || propInMindCode === 'Y')? data.sgBuilding:'', //existing
            godown_Number:  (isRefinance || propInMindCode === 'Y')? data.sgGodownNo:'', //existing
            lot_Mukim_Number:  (isRefinance || propInMindCode === 'Y')? data.sgLotMukimNo:'', //existing
            box_Number: (isRefinance || propInMindCode === 'Y')?data.sgBoxNo:'', //existing
            locked_Bag_Number:  (isRefinance || propInMindCode === 'Y')?data.sgLockedBagNo:'', //existing
            post_Office_Name: (isRefinance || propInMindCode === 'Y')?data.sgPostOffice:'', //existing
            house_Number:  (isRefinance || propInMindCode === 'Y')?data.sgHouseNo:'', //existing
            window_Delivery_Number: (isRefinance || propInMindCode === 'Y')?data.sgWindowDeliveryNo:'', //existing
           
            address_Line1:'',  //remove
            address_Line2: '', //remove 
            address_Line3: '', //remove
 
            city: data.city, //existing
            state: data.state, //existing

            isSixMonthsBankBalWithMaybank:isSixMonthsBankBalWithMaybankCode,
            isSixMonthsBankBalWithMaybankDescription: isSixMonthsBankBalWithMaybankDesc,

            isActiveBizAcctWithOtherBanks: isActiveBizAcctWithOtherBanksCode,
            isActiveBizAcctWithOtherBanksDesc: isActiveBizAcctWithOtherBanksDesc,

            bankBalanceDetails:bankBalDtlsArray,
            monthlyDebtCommitments: monthlyDebtCommitArray,

            latestAnnualIntrestExpense:latestAnnIntExpAmt,
            latestAnnualIntrestExpenseCurrency:latestAnnIntExpCCY,
    
            latestAnnualDepreciationOrAmortisationAmt:latestAnnIntDepOrAmortAmt,
            latestAnnualDepreciationOrAmortisationAmtCurrency:latestAnnIntDepOrAmortCCY
        }

        return params;
    }

    const bindBankBalanceList = (bbArray) => {
        let formattedArray = [];
        if(bbArray === '' || bbArray === null) {
            return formattedArray;
        }
        if(bbArray.length > 0){
            for(let i in bbArray) {
                const fObj = {
                    detailsId: bbArray[i].detailsId,
                    accountNumber: bbArray[i].accountNumber,
                    bankName:{
                        value:bbArray[i].bankName,
                        label:bbArray[i].bankNameDescription
                    },
                    currency:{
                        value:bbArray[i].currency,
                        label:bbArray[i].currencyDescription
                    },
                    sixMonthsBalanceAmt: bbArray[i].sixMonthsBalanceAmt
                }
    
                formattedArray.push(fObj);
            }
        }
        else {
            formattedArray = [];
        }
     
      
       setBankBalanceList(formattedArray);
    }

    const bindMontlyDebtCommitments = (mdcArray) => {
        // console.log('bindMontlyDebtCommitments: ',mdcArray);
        let formattedArray = [];
        if(mdcArray === '' || mdcArray === null) {
            return formattedArray;
        }
        if(mdcArray.length > 0) {
            for(let i in mdcArray) {
                const fObj = {
                    ddlLoanProdType:{
                        value:mdcArray[i].loanProductType,
                        label:mdcArray[i].loanProductTypeDescription
                    },
                    ddlNoOfBank:{
                        value:mdcArray[i].numberOfBanks,
                        label:mdcArray[i].numberOfBanksDescription
                    },
                    amount: mdcArray[i].amount,
                }
         
                formattedArray.push(fObj);
            }
        }
        else {
            formattedArray = [];
        }
 
        // console.log('bindMontlyDebtCommitments: ',formattedArray);
        setMonthlyDebtCommitList(formattedArray);
    }

    const formatBankBalanceList = () => {
        let result = []; 
        if(selectedRdoHasOthBankAcct === 'N') {
            result = [];
        }
        else if(bankBalanceList.length > 0) {
            for(let i in bankBalanceList){
                const idValue = parseInt(i)+1;
                const bbObj = {
                    detailsId: 'id'+idValue,
                    bankName: bankBalanceList[i].bankName.value,
                    bankNameDescription: bankBalanceList[i].bankName.label,
                    accountNumber: bankBalanceList[i].accountNumber,
                    currency:bankBalanceList[i].currency.value,
                    currencyDescription:bankBalanceList[i].currency.label,
                    sixMonthsBalanceAmt: bankBalanceList[i].sixMonthsBalanceAmt
                }
                result.push(bbObj);
            }
        }
     
        return result;
    }

    const formatMonthlyDebtCommitList = ()=> {
        
        let result = []; 
        if(monthlyDebtCommitList.length > 0) {
            for(let i in monthlyDebtCommitList){
                const mdcObj= monthlyDebtCommitList[i];
                let formatObj = {};
                const idValue = parseInt(i)+1;
                if(mdcObj.ddlLoanProdType !== null && mdcObj.ddlNoOfBank !== null && mdcObj.amount !== null) {
                    formatObj = {
                        mdcId: 'id'+idValue,
                        loanProductType: mdcObj.ddlLoanProdType.value,
                        loanProductTypeDescription: mdcObj.ddlLoanProdType.label,
                        numberOfBanks:mdcObj.ddlNoOfBank.value,
                        numberOfBanksDescription:mdcObj.ddlNoOfBank.label,
                        amount: mdcObj.amount
                    }
                    result.push(formatObj)
                }
            }
        }
        return result;
    }

    const isValidRdoFields = () => {
 
        let isValid = true;

        if(!selectedRdoTypeOfFinancing || selectedRdoTypeOfFinancing === null) { // type of financing empty
            isValid = false;
            showErrMsg(pData.error.rdoRefinance);
            return;
        }
 

        //selectedRdoTypeOfFinancing !== null, check rdoPurpose
        if(selectedRdoTypeOfFinancing === pData.typeOfFinanceRdo.firstValue) { 
            //NEW PURCHASE
            if(selectedRdoPurpose === null) {
                isValid = false;
                showErrMsg(pData.error.rdoPurpose);
                return;
            }
            //selectedRdoPurpose !== null, check rdoPropertyInMind
            if(selectedRdoPropertyInMind === null) { //Y
                isValid = false;
                showErrMsg(pData.error.rdoPropertyInMind);
                return;
            }
    
            //selectedRdoPropertyInMind !== null, check selectedRdoPropertyInMind is Y && address search AddType
            if(selectedRdoPropertyInMind === 'Y') {

                if(isPureAIP === true && selectedRdoIsLeasehold === null) {
                    isValid = false;
                    showErrMsg(pData.error.rdoIsLeasehold);
                    console.log('show NO LEASEHOLD')
                    return;
                }
                
                if(sgAddTypeResult === null){
                    isValid = false;
                    showErrMsg(pData.error.invalidAddType);
                    console.log('show NO ADD TYPE')
                    return;
                }
            }

            if(isPureAIP) {
                if(selectedRdoHasMaybankAcct === null) {
                    isValid = false;
                    showErrMsg(pData.error.rdoHasMBAcct);
                    console.log('show rdoHasMBAcct empty err')
                    return;
                }
                else {//HAS MBACCT 

                    if(selectedRdoHasOthBankAcct === null) { //HAS OTH BANK ACCT
                        isValid = false;
                        showErrMsg(pData.error.rdoHasOthBizAcct);
                        return;
                    }

                    if(selectedRdoHasMaybankAcct === 'N' && selectedRdoHasOthBankAcct === 'N') {
                        isValid = false;
                        showErrMsg(pData.error.invalidMBOrOthAcct);
                        return;
                    }

                    if(selectedRdoHasOthBankAcct === 'Y') { // NO MBACCT, CHECK Bankbalance List
                        if(bankBalanceList.length === 0) {
                            isValid = false;
                            showErrMsg(pData.error.noBankBanlanceList);
                            console.log('NO BB LIST')
                            return;
                        }
                    }
                }

                if(!isValidDebtCommitmentFields()){
                    showErrMsg(pData.error.noMonthlyDebts);
                    return;
                }
            }
        }
        else { //REFINANCE
            if(sgAddTypeResult === null) {
                console.log('Refinance')
                isValid = false;
                showErrMsg(pData.error.invalidAddType);
                return;
            }
        }

        return isValid;
    }
    
    const handleBack = (e) => {
        e.preventDefault();
  
        history.push(config.route.NSPersonDetails);
    }

    const showPropAddressSection = () => {
        let isShow = false;
        if(selectedRdoTypeOfFinancing === null) {
            isShow = false;
        }
        else {
            if(selectedRdoTypeOfFinancing === pData.typeOfFinanceRdo.secValue){ //refinancing
                isShow = true;
            }
            else if(selectedRdoPropertyInMind === 'Y'){
                isShow = true;
            }
            else {
                isShow = false;
            }
        }
       
        return isShow;
    }

    const showPropAddressFooter = () => {
        let isShow = false;
        if(showPropAddressSection() && !isPureAIP) {
            isShow = true;
        }

        return;
    }

    const leaseHoldEffDateValidator = (value) => {
        // console.log('leaseHoldEffDateValidator', value);
        if (value === null || value === undefined) {
          return "You cannot leave this field blank.";
        } 
        // else if (value >= todayDate) {
        //   return "Date Of Signed Sales Agreement should not be future-dated.";
        // } 
        else {
          return "";
        }
    };

    const resetFormFields = () => {
        try{
            setInitFormData({
                latestOutstandingLoanAmt:null,
                propertyTypeCbo:null,  // existing 
                purchasePriceValue:null, //numeric,
                latestOutstandingLoanAmt:null,
                leaseHoldEffDate: null, //date dd/MM/yyyy
                originalLeaseHoldCbo:null, // new
                origLeaseHoldOth:'', //new if originalLeaseHoldCbo is Oth
        
                sgPostalCode: "", // existing 
                sgBlkNo: "", // existing 
                sgStreet: "", // existing 
                sgStoreyNo: "", // existing 
                sgUnitNo: "", // existing 
                sgBuilding: "", // existing 
                sgLockedBagNo: "", // existing 
                sgGodownNo: "",  // existing 
                sgLotMukimNo:"", // existing 
                sgBoxNo: "", // existing 
                sgPostOffice: "", // existing 
                sgHouseNo: "", // existing 
                sgWindowDeliveryNo: "",// existing 
        
                city:'', // existing 
                state:'',// existing 
                postal_Code:'',// existing 
        
                latestAnnIntExpCurrencyCbo:{"value":"SGD","label":"SGD"},//new default to SGD
                latestAnnIntExp:null, //numeric new 
        
                latestAnnIntDepOrAmortCurrencyCbo:{"value":"SGD","label":"SGD"}, //new default to SGD
                latestAnnIntDepOrAmort:null
            })
        }catch(e){

        }
    }

    const getAddressbyPostalCode = (postalCode,formProps) => {
      
        setIsSearching(true);
        
        addService.getAddress(postalCode).then(res=>{

            let data = res.data.model;
            let resdata = data[0];
            let addTypeCode = '';
            if(resdata.addR_TYP_CODE === '' || resdata.addR_TYP_CODE === undefined || resdata.addR_TYP_CODE === null) {
                if(resdata.addR_FMT_CODE === '' || resdata.addR_FMT_CODE === undefined || resdata.addR_FMT_CODE === null) {
                  addTypeCode = config.AddType.Local;
                }
                else {
                  addTypeCode = resdata.addR_FMT_CODE;
                }
            }
            else {
                addTypeCode = resdata.addR_TYP_CODE;
            }
         
            setSgAddTypeResult(addTypeCode);

            checkLocalAddStatus(formProps,addTypeCode,resdata,addressTag);
        })
        .catch(err=>{
            setIsSearching(false);
            console.log('err: ',err);
            resetAddressFields(formProps,addressTag);
            showErrMsg(config.error.GetApiFailed);
            return;
        })
    }

    const checkLocalAddStatus = (fProps,addTypeCodeResult,resdata,tag) => {

        let addTypeCode , blkno='', building='', street='', stCityName = '',poBox ='',unitNo='',storeyNo='';
        let postOfficeName='', lockedBagNo='', goDownNo='', houseNo='', winDeliNo='', lotMukimNo='';
        
        addTypeCode = addTypeCodeResult;
        if(resdata.blK_NO === '' || resdata.blK_NO === undefined || resdata.blK_NO === null) {
            blkno = '';
            lockedBagNo = '';
            goDownNo = '';
            winDeliNo = '';
            houseNo = '';
            lotMukimNo = '';
        }
        else {
            if(addTypeCode === config.addTypeMultiStorery){    //H
                blkno = resdata.blK_NO;
            }
            else if(addTypeCode === config.addTypeLockedBag) { //B
                lockedBagNo = resdata.blK_NO;
            }
            else if(addTypeCode === config.addTypeGodown) { //G
                goDownNo = resdata.blK_NO;
            }
            else if(addTypeCode === config.addTypeWindowDeli) { //W
                winDeliNo =  resdata.blK_NO;
            }
            else if(addTypeCode === config.addTypeHouseShopWalkupApmt) {//S
                houseNo = resdata.blK_NO;
            }
            else if (addTypeCode === config.addTypeLotMukim) { //L
                lotMukimNo = resdata.blK_NO;
            }  
        }

        if(resdata.bldG_NAME === '' || resdata.bldG_NAME === undefined || resdata.bldG_NAME === null) {
            building = '';
        }
        else {
            if(addTypeCode === config.addTypeGodown || addTypeCode === config.addTypeMultiStorery || addTypeCode === config.addTypeHouseShopWalkupApmt) {//G,H,S
                building = resdata.bldG_NAME;
            }
            else if(addTypeCode === config.addTypeLockedBag || addTypeCode === config.addTypePObox || config.addTypeWindowDeli) {//B,P,W
                postOfficeName = resdata.bldG_NAME;
            }
        }

        if(resdata.poboX_NO === '' || resdata.poboX_NO === undefined || resdata.poboX_NO === null) {
            poBox = '';
        }
        else {
            poBox = resdata.poboX_NO;
        }

        if(resdata.sT_NAME === '' || resdata.sT_NAME === undefined || resdata.sT_NAME === null) {
            street = '';
        }
        else {
            if(addTypeCode === config.addTypeGodown || addTypeCode === config.addTypeMultiStorery 
            ||addTypeCode === config.addTypeHouseShopWalkupApmt || addTypeCode === config.addTypeLotMukim) {//G,H,S,L
                street = resdata.sT_NAME;
            }
            else {
                street = '';
            }
        }

        if(resdata.staT_CITY_NAME === '' || resdata.staT_CITY_NAME === undefined || resdata.staT_CITY_NAME === null) {
            stCityName = defSgDesc;
        }
        else {
            stCityName = resdata.staT_CITY_NAME;
        }

        if(resdata.uniT_NO === '' || resdata.uniT_NO === undefined || resdata.uniT_NO === null) {
            unitNo = '';
        }
        else if(addTypeCode === config.addTypeGodown || addTypeCode === config.addTypeMultiStorery) {//G,H
            unitNo = resdata.uniT_NO;
        }

        if(resdata.strY_NO === '' || resdata.strY_NO === undefined || resdata.strY_NO === null) {
            storeyNo = '';
        }
        else {
            storeyNo = resdata.strY_NO;
        }
 
        fProps.onChange(tag+"BlkNo", {
          value: blkno,
        });
        fProps.onChange(tag+"Building", {
          value: building,
        });
        fProps.onChange(tag+"StoreyNo", {
          value: storeyNo,
        });
        fProps.onChange(tag+"UnitNo", {
          value: unitNo,
        });
        fProps.onChange(tag+"Street", {
          value: street,
        });
        fProps.onChange(tag+"LockedBagNo", {
          value: lockedBagNo,
        });
        fProps.onChange(tag+"GodownNo", {
          value: goDownNo,
        });
        fProps.onChange(tag+"LotMukimNo", {
          value: lotMukimNo,
        });
        fProps.onChange(tag+"BoxNo", {
          value: poBox,
        });
        fProps.onChange(tag+"PostOffice", {
          value: postOfficeName,
        });
        fProps.onChange(tag+"HouseNo", {
          value: houseNo,
        });
        fProps.onChange(tag+"WindowDeliveryNo", {
          value: winDeliNo,
        });

        // console.log('street',fProps.valueGetter(tag+'Street'))
        setIsSearching(false);
    }

    const resetAddressFields = (fProps,tag) => {
        fProps.onChange('sgPostalCode',{
            value:''
        });
        fProps.onChange(tag+"BlkNo", {
            value: '',
          });
          fProps.onChange(tag+"Building", {
            value: '',
          });
          fProps.onChange(tag+"StoreyNo", {
            value: '',
          });
          fProps.onChange(tag+"UnitNo", {
            value: '',
          });
          fProps.onChange(tag+"Street", {
            value: '',
          });
          fProps.onChange(tag+"LockedBagNo", {
            value: '',
          });
          fProps.onChange(tag+"GodownNo", {
            value: '',
          });
          fProps.onChange(tag+"LotMukimNo", {
            value: '',
          });
          fProps.onChange(tag+"BoxNo", {
            value: '',
          });
          fProps.onChange(tag+"PostOffice", {
            value: '',
          });
          fProps.onChange(tag+"HouseNo", {
            value: '',
          });
          fProps.onChange(tag+"WindowDeliveryNo", {
            value: '',
          });
    }

    const handleCommitmentPopupClose = () => {
        setAddCommitmentPopup(false);
    }

    const handleAddCommitment = (newData,isCommitUpdated) => {
        // console.log('handleAddCommitment', newData);
        // console.log('isCommitUpdated', newData);
        setAddCommitmentPopup(false);
        let tempArray = [];
        const list = [...monthlyDebtCommitList];

        if(isCommitUpdated){ //bank balance updated
            const i = mdcIndex;
            list[i] = newData;

            if(list.length > 1) {
                for(let k in list) {
                    if(parseInt(k) === i) {
                        // console.log('same idx',k,i)
                    }
                    else {
                        // console.log('not same idx',k,i)
                        const mdcItem = list[k];
                        if(mdcItem.ddlLoanProdType.value === newData.ddlLoanProdType.value) {
                            showErrMsg(pData.error.sameProdType);
                            return;
                        }
                    }
                }
            }
        
            setMonthlyDebtCommitList(list);
        }
        else { //NEW ITEM ADD
            // console.log('list.length: ',list.length)
            if(list.length >= 1) {
                // console.log('new add')
                if(!isDuplicateMonthlyDebtCommit(list, newData,isCommitUpdated)) {
                    showErrMsg(pData.error.sameProdType)
                    return;
                }
            }

            if(list.length > 0) {
                tempArray = list;
                tempArray.push(newData);
            }
            else {
                list.push(newData);
            }
        }

        setMonthlyDebtCommitList(list);
    }

    const handlePopupClose = () => {
        setAddBankBalancePopup(false);
    }

    const handleAddBankBalance = (newData,isBankBalUpdated) => {
        // console.log('handleAddBankBalance',data,isBankBalUpdated);

        setAddBankBalancePopup(false);

        let tempArray = [];
        const list = [...bankBalanceList];

        if(isBankBalUpdated){ //bank balance updated
            const i = bankBalIndex;
            list[i] = newData;

            if(list.length > 1) {
                for(let k in list) {
                    if(parseInt(k) === i) {
                        // console.log('same idx',k,i)
                    }
                    else {
                        // console.log('not same idx',k,i)
                        const bbItem = list[k];
                        if(bbItem.bankName.value === newData.bankName.value &&
                            bbItem.accountNumber === newData.accountNumber &&
                            bbItem.currency.value === newData.currency.value) {
                            showErrMsg(pData.error.duplicateEntries);
                            return;
                        }
                    }
                }
            }
        
            setBankBalanceList(list);
        }
        else { //NEW ITEM ADD
            // console.log('list.length: ',list.length)
            if(list.length >= 1) {
                // console.log('new add')
                if(!isDuplicateBankBalance(list, newData,isBankBalUpdated)) {
                    showErrMsg(pData.error.duplicateEntries)
                    return;
                }
            }

            if(list.length > 0) {
                tempArray = list;
                tempArray.push(newData);
            }
            else {
                list.push(newData);
            }
        }

        setBankBalanceList(list);
    }

    const isDuplicateBankBalance = (arrayList, newData) => {
        let isValid = true;

        for(let i in arrayList) {
            const bbItem = arrayList[i];
            if(bbItem.bankName.value === newData.bankName.value &&
                bbItem.accountNumber === newData.accountNumber &&
                bbItem.currency.value === newData.currency.value) {
                    isValid = false;
                    return isValid;
            }
        }
        return isValid;
    }

    const isDuplicateMonthlyDebtCommit = (arrayList, newData) => {
        let isValid = true;

        for(let i in arrayList) {
            const mdcItem = arrayList[i];
            if(mdcItem.ddlLoanProdType.value === newData.ddlLoanProdType.value) {
                    isValid = false;
                    return isValid;
            }
        }
        return isValid;
    }

    const handleDDLLoanProdType = (e,i) => {
        // console.log('handleDDLLoanProdType',e.value);
        if(e.value !== null) {
            if(isExistingLoanProdType(e.value.value, monthlyDebtCommitList)){
                showErrMsg(pData.error.sameProdType);
                return;
            }  
            
            //no existing value
            const list = [...monthlyDebtCommitList];
            list[i].ddlLoanProdType = e.value;
            setMonthlyDebtCommitList(list);
        }

    }

    const handleDDLNoOfBank = (e,i) => {
        // console.log('handleDDLNoOfBank',e.value);
        const list = [...monthlyDebtCommitList];
        
        list[i].ddlNoOfBank = e.value;
        setMonthlyDebtCommitList(list);
    }

    const isValidDebtCommitmentFields = () => {
        let isValid = true;
        /*
        const arrayList= monthlyDebtCommitList;
 
        if(arrayList.length > 0) {
            for(let i = 0; i < arrayList.length; i++) {
                // console.log('ivalue: ', i)
                const lastRow =arrayList.length-1;  //last row
                const mdcValue = arrayList[i];
                if(i !== lastRow) {
                    if(mdcValue.ddlLoanProdType ===null || mdcValue.ddlNoOfBank === null ||mdcValue.amount === null){
                        isValid = false;
                        return isValid;
                    }
                }
                else { // i is last row 
                  isValid = true;
                }
            }
        }
        else {
            isValid = true;
        }
        */
      
        if(monthlyDebtCommitList.length > 0) {
            const l =monthlyDebtCommitList.length;
            const k =l-1;
            const kValue = monthlyDebtCommitList[k];
        
            if(kValue.ddlLoanProdType !==null) {
                if(kValue.ddlNoOfBank === null || kValue.amount===null) {
                    showErrMsg(pData.error.noMonthlyDebts);
                    isValid = false;
                    return;
                }
            }
            else {
                isValid = true;
            }
        }

        return isValid;
     
    }

    const isExistingLoanProdType = (selectedValue,array) => {
        let result = false;
        if(array.length > 0) {
            for(let i in array) {
                if(array[i].ddlLoanProdType !== null) {
                    const exitingValue  = array[i].ddlLoanProdType.value;
                    if(selectedValue === exitingValue) {
                        result = true;
                        return result;
                    }
                }
                else {
                    return result;
                }
            }
        }

        return result;
    }

    const showErrMsg = (msg) => {
        setIsError(true);
        setErrMsg(msg);
        setErrMsgTimeout();
    }

    const setErrMsgTimeout= () => {
        timer = setTimeout(() => {
            setIsError(false);
        }, config.error.msgTimeout);
    }
    
    const isEmptyObj = (obj)=> {
        if(obj === null) return true;
        return Object.keys(obj).length === 0;
      }

    const getLastSixMonths = () => {
        const months = [];
        const currentDate = new Date();
        for (let i = 1; i < 7; i ++) {
            const date = new Date(currentDate);
            date.setMonth(date.getMonth() - i);
            const monthYear = date.toLocaleString('default',{month:'long',year: 'numeric'})
            months.push(monthYear);
        }

        return months;
    }

    const removeMonthlyDebitCommit = (index) => {
        console.log('removeMonthlyDebitCommit ',index);
        let list = [...monthlyDebtCommitList];
 
        list.splice(index,1);

        setMonthlyDebtCommitList(list);
    }

    const goNext = () => {
        if(history.location.state !== undefined) {

            if(history.location.state.from === config.route.Preview) {
                history.goBack();
            }
            else {
                console.log('not form preview!')
                history.push(config.route.DeclarationsDetails);
            }
        }
        else {
            history.push(config.route.DeclarationsDetails);
        }
    }

    //currency filter
    const filterCurrencyData = (filter) => {
        const data = currencies.slice();
        return filterBy(data, filter);
    };
    
    const filterLatestAnnIntExpCurrencyCboChange = (event) => {
        setLatestAnnIntExpCurrencies(filterCurrencyData(event.filter));
    };

    const filterLatestAnnIntDepOrAmortCurrencyCboChange = (event) =>{
        setLatestAnnIntDepOrAmortCurrencies(filterCurrencyData(event.filter));
    }

    if(isLoading) {
        return(
          <Loading />
        )
    }
    return(
        <div className="container-fluid">
        <SubHeader title={config.Branding.title} img={headerImg}/> <br/>
        <Form
            onSubmitClick={handleSubmit} 
            initialValues={initFormData}
            key={JSON.stringify(initFormData)}
            render={(formRenderProps) => (
                <FormElement>
                    <FormContainer>
                        <fieldset className={"k-form-fieldset"}>
                            <FieldWrapper>
                                <Field component={FormTitleHybrid} id={'ft1'} name={pData.mainTitle}/>
                            </FieldWrapper>
                            <FieldWrapper>
                                <CusRadioG2Btn 
                                    name="rdoGroupTypeOfFinance" 
                                    firstValue={pData.typeOfFinanceRdo.firstValue} 
                                    secValue={pData.typeOfFinanceRdo.secValue} 
                                    label={pData.label.typeOfFinance} 
                                    firstValueLabel={pData.typeOfFinanceRdo.firstValueLbl}
                                    secValueLabel={pData.typeOfFinanceRdo.secValueLbl}
                                    onChange={handleTypeOfFinanceRdoChange} 
                                    checkedValue={selectedRdoTypeOfFinancing} />   
                            </FieldWrapper>
                   
                            {/* NEW_PURCHASE -START */}
                            {selectedRdoTypeOfFinancing === pData.typeOfFinanceRdo.firstValue &&
                            <>
                                <FieldWrapper>
                                    <CusRadioG2Btn 
                                        name="rdoGroupPurpose" 
                                        firstValue={pData.purposePropertyRdo.firstValue} 
                                        secValue={pData.purposePropertyRdo.secValue} 
                                        label={pData.label.purpose} 
                                        firstValueLabel={pData.purposePropertyRdo.firstValueLbl}
                                        secValueLabel={pData.purposePropertyRdo.secValueLbl}
                                        checkedValue={selectedRdoPurpose}
                                        onChange={(e) => {
                                            const propTypeCbo = formRenderProps.valueGetter('propertyTypeCbo');
                                            let selectedPropType = propTypeCbo? propTypeCbo.value:'';
                                            handleRdoGroupPurposeChange(e,selectedPropType);
                                        }}  />   
                                </FieldWrapper>

                                {/* rdoPropertyInMind SECTION - Applied HYBRID & AIP, selectedRdoPurpose !== null */}
                                {(selectedRdoPurpose !== null)&&
                                <FieldWrapper>
                                <CusRadioButton name="rdoPropertyInMind" 
                                    leftValue={pData.propertyInMindRdo.leftValue} rightValue={pData.propertyInMindRdo.rightValue} disabled={false}
                                    leftValueLabel={pData.propertyInMindRdo.leftValueLbl} rightValueLabel={pData.propertyInMindRdo.rightValueLbl}
                                    label={pData.label.propertyInMind} labelDesp={''}
                                    checkedValue={selectedRdoPropertyInMind}
                                    onChange={(e)=> {
                                        const propTypeCbo = formRenderProps.valueGetter('propertyTypeCbo');
                                        let selectedPropType = propTypeCbo? propTypeCbo.value:'';
                                        setSelectedRdoPropertyInMind(e.value);
                                        if(selectedRdoPurpose === pData.purposePropertyRdo.secValue) {
                                            setIsPureAIP(false); 
                                        }
                                        else {
                                            if((e.value === 'Y') && selectedPropType === pData.propTypeShopCode) {
                                                setIsPureAIP(false); 
                                            }
                                            else {
                                                setIsPureAIP(true); 
                                            }
                                        }
                                    }} 
                                />
                                </FieldWrapper>
                                }

                                {selectedRdoPropertyInMind === 'Y' &&
                                <div>
                                    <FieldWrapper>
                                        <Field leftLabelId={'lblPropertyType'} 
                                            leftLabelName={pData.label.propertyType}
                                            id={'propertyTypeCbo'} 
                                            name={'propertyTypeCbo'}
                                            component={CusFormComboBox} 
                                            textField={'label'}
                                            disabled={false}
                                            data={pTypes} 
                                            placeholder={'Please select'} 
                                            validator={reqDDLValidator}
                                            onChange={handlePropertyTypeCboChange} />

                                        <Field component={CusFormNumericTextBox} 
                                            leftLabelId={'lblPurchasePrice'} 
                                            leftLabelName={pData.label.purchasePrice} 
                                            id={'purchasePriceValue'} 
                                            name={'purchasePriceValue'} 
                                            placeholder={'S$0'}
                                            validator={decimalValidator}
                                            spinners={false} 
                                            format="c2"
                                        />
                                    </FieldWrapper>

                                    {/* IS LEASEHOLD Y/N SECTION - ONLY FOR PURE AIP*/}
                                    {isPureAIP &&
                                    <FieldWrapper>
                                        <CusRadioButton name="rdoIsLeasehold" 
                                            leftValue={pData.isLeaseholdRdo.leftValue} rightValue={pData.isLeaseholdRdo.rightValue} disabled={false}
                                            leftValueLabel={pData.isLeaseholdRdo.leftValueLbl} rightValueLabel={pData.isLeaseholdRdo.rightValueLbl}
                                            label={pData.label.isLeasehold} labelDesp={''}
                                            onChange={handleRdoIsLeaseholdChange} 
                                                checkedValue={selectedRdoIsLeasehold} />
                                            {/* IsLeasehold Yes */}
                                            {selectedRdoIsLeasehold === 'Y' &&
                                            <>
                                            <Field
                                                component={CusFormCalenInput}
                                                leftLabelId={"lblLeaseEffectDate"}
                                                leftLabelName={pData.label.leaseHoldEffDate}
                                                key={'leaseHoldEffDate'}
                                                id={"leaseHoldEffDate"}
                                                name={"leaseHoldEffDate"}
                                                format="dd-MM-yyyy"
                                                formatPlaceholder="formatPattern"
                                                placeholder="eg. 31-01-2024"
                                                required={true}
                                                max={todayDate}
                                                dateValue={leaseHoldEffDateInputValue}
                                                validator={leaseholdDateValidator}
                                                onChange={(e)=> {
                                                    // console.log('leaseHoldEffDate onChange',e)
                                                    setLeaseHoldEffDateInputValue(e.value);
                                                }}
                                            />
                                        
                                            <Field leftLabelId={'lblOriLeaseHold'} 
                                                leftLabelName={pData.label.originalLeaseHold}
                                                id={'originalLeaseHoldCbo'} 
                                                name={'originalLeaseHoldCbo'}
                                                component={CusFormComboBox}
                                                textField={'label'}
                                                data={pData.origLeaseHoldDDLList}
                                                placeholder={'Please select'}
                                                validator={reqDDLValidator} 
                                                value={origLeaseHoldValue}
                                                onChange={handleOriginalLeaseHoldChange}
                                            />
                               
                                            {(origLeaseHoldValue !== null && origLeaseHoldValue.value === 'Others')&&
                                            <Field component={CusFormInput} 
                                                leftLabelId={'lblOrigLeaseHoldOth'} 
                                                leftLabelName={'Others'} 
                                                id={'origLeaseHoldOth'} 
                                                name={'origLeaseHoldOth'} 
                                                placeholder={'Please input leasehold years'}
                                                maxLength={80}  
                                                validator={numericValidator} />
                                            }
                                            </>
                                            }
                                    </FieldWrapper> 
                                    }
                                </div>
                                }
                            </>
                            } 
                            {/* NEW_PURCHASE -END */}
                            {/* REFINANCE - START */}
                            {selectedRdoTypeOfFinancing === pData.typeOfFinanceRdo.secValue &&
                            <>
                                <Field component={CusFormNumericTextBox} 
                                    leftLabelId={'lblLatestOutLoanAmt'} 
                                    leftLabelName={pData.label.latestOutLoanAmt} 
                                    id={'latestOutLoanAmtValue'} 
                                    name={'latestOutLoanAmtValue'} 
                                    placeholder={'S$0'}
                                    validator={zeroDecimalValidator}
                                    spinners={false} 
                                    format="c2"
                                />
                            </>
                            }
                        </fieldset>
                        <br/>
                    </FormContainer>
                    {/* PROPERTY ADDRESS SECTION - Applied HYBRID & AIP, RdoPropertyInMind Y ONLY */}
                    {(showPropAddressSection()) &&
                    <FormContainer>
                        <fieldset>
                            <FieldWrapper>
                                <Field component={FormTitleTooltip} id={'ft2'} name={pData.formTitle.ft2}
                                    tooltipPosition={'right'} tooltipAchor={'target'} 
                                    tooltipTitle={pData.tooltipText.ft2}
                                />
                            </FieldWrapper>
                      
                            <FieldWrapper>
                                <div className="row around-xs inputPair elementVisible">
                                    <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                        <div className="box" style={{ marginTop: "5px" }}>{pData.label.PostalCode}</div>
                                    </div>
                                    <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                        <div style={{width:'90%', float:'left'}}>
                                            <Field className="k-textbox" name={'sgPostalCode'} id={'sgPostalCode'}
                                                placeholder={'eg. 569083'} 
                                                maxLength={6} 
                                                component={FormInput} 
                                                validator={postalCodeValidator} 
                                                onKeyDown={e => {
                                                    if(e.keyCode === 13) {
                                                        e.preventDefault();
                                                
                                                        let postalCode = formRenderProps.valueGetter('postal_Code');
                                                    
                                                        getAddressbyPostalCode(postalCode,formRenderProps);
                                                    }
                                                }}
                                                />
                                        </div>
                                        <div style={{width:'10%', float:'left', textAlign:'center',paddingLeft:'5px'}}>
                                            <a className="k-icon k-i-zoom" style={{fontSize:'22px'}} onClick={(e)=>{
                                                e.preventDefault();
                               
                                                let postCode = formRenderProps.valueGetter('sgPostalCode');
                                                if(postCode === '' || postCode === undefined) {
                                                    return;
                                                }
                                                else if(postCode.length > 6 || !numericRegex.test(postCode) ) {
                                                    return;
                                                }
                                              
                                                getAddressbyPostalCode(postCode,formRenderProps);

                                                }}>
                                            </a>
                                            <div style={{fontSize:'10px'}} >Search</div>
                                           
                                        </div>
                                    </div>
                                </div>

                                <LocalAddress id={addressTag} addressType={sgAddTypeResult} />
                         
                            </FieldWrapper>
                     
                        </fieldset>
                    <br/>
                    </FormContainer>
                    }
                    {/* Maybank Account Details SECTION */}
                    {(isPureAIP && selectedRdoPropertyInMind !== null) &&
                    <FormContainer>
                        <fieldset>
                            <FieldWrapper>
                                <Field component={FormTitleHybrid} id={'ft3'} name={pData.formTitle.ft3}/>
                            </FieldWrapper>
                            <div>
                                <CusRadioButton name="rdoHasMaybankAcct" 
                                    leftValue={pData.hasMaybankAcctRdo.leftValue} 
                                    rightValue={pData.hasMaybankAcctRdo.rightValue} disabled={false}
                                    leftValueLabel={pData.hasMaybankAcctRdo.leftValueLbl} 
                                    rightValueLabel={pData.hasMaybankAcctRdo.rightValueLbl}
                                    label={pData.label.hasMaybankAcct} labelDesp={''}
                                    onChange={handleRdoHasMaybankAcctChange} 
                                    checkedValue={selectedRdoHasMaybankAcct} />
                            </div>
                
                            <FieldWrapper>
                                <Field component={FormTitleHybrid} id={'ft4'} name={pData.formTitle.ft4}/>
                            </FieldWrapper>
                            <div>
                                <CusRadioButton name="rdoHasOtherActiveBizAcct" 
                                    disabled={false}
                                    leftValue={pData.hasOthBankAcctRdo.leftValue} 
                                    rightValue={pData.hasOthBankAcctRdo.rightValue} 
                                    leftValueLabel={pData.hasOthBankAcctRdo.leftValueLbl} 
                                    rightValueLabel={pData.hasOthBankAcctRdo.rightValueLbl}
                                    label={pData.label.hasOthActiveBankAcct} labelDesp={''}
                                    onChange={handleRdoHasOthBankAcctChange} 
                                    checkedValue={selectedRdoHasOthBankAcct} />
                            </div>
                            {(selectedRdoHasOthBankAcct === 'Y') && 
                            <>
                            <div>
                                <div className="row around-xs inputPair elementVisible">
                                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        {/* <div className='acct-bal-txt-div txt-grey-fs16'>
                                            {(selectedRdoHasMaybankAcct === 'N')?pData.label.addAcctBalanceNo:pData.label.addAcctBalanceYes}
                                        </div> */}
                                        <div className='acct-bal-btn-div'>
                                            <button id={'btnBankBalanceAdd'} className="box no-border-bg-white"
                                                disabled={false}
                                                    onClick={ e => {
                                                    e.preventDefault();
                                                    if(selectedRdoHasMaybankAcct === null) {
                                                        showErrMsg(pData.error.rdoHasMBAcct);
                                                        return;
                                                    }
                                                    setBankBalanceItem(null);
                                                    setAddBankBalancePopup(true);
                                                }}>
                                                <span className="k-icon k-i-plus add-btn-blue"></span>&nbsp;
                                                <span className='add-btn-blue'>{'Add Balance Details'}</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <FieldWrapper>
                                <BankBalanceHistory data={bankBalanceList}
                                    isFromPreview={false} 
                                    onItemClick={(btnAction,indexNo,bbItem)=>{
                                        // console.log('onItemClick: ',btnAction,indexNo,bbItem);
                                        if(btnAction==='EDIT') {
                                            setAddBankBalancePopup(true);
                                            setBankBalanceItem(bbItem);
                                            setBankBalIndex(indexNo);
                                            return;
                                        }
                                        if(btnAction==='REMOVE') {
                                            let bbList = [...bankBalanceList];
 
                                            bbList.splice(indexNo,1);
                                            setBankBalanceList(bbList);
                                        }
                                    }}
                                />
                            </FieldWrapper>
                            </>}
                            {addBankBalancePopup &&
                            <AddBankBalncePopup popupValue={addBankBalancePopup} setTrigger={handlePopupClose}
                                lastSixMonths={lastSixMonthsArray}
                                fProps={formRenderProps}
                                editedItem ={bankBalanceItem}
                                onClickAdd={handleAddBankBalance}
                            />
                            }
                            
                            <div className="divgreylineCpf div-mrg" />
                            <FieldWrapper>
                                <Field component={FormTitleHybrid} id={'ft5'} name={pData.formTitle.ft5}/>
                                {/* <Field component={HybridFormLabelGrey} labelId={'lblGraySubft2'} labelName={pData.label.debtCommit} />     */}
                            </FieldWrapper>
                            <div>
                                <div className="row around-xs inputPair elementVisible">
                                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <div className='mdc-txt-div txt-grey-fs16'>
                                        {pData.label.debtCommit}
                                        </div>
                                        <div className='mdc-btn-div'>
                                            <button id={'btnAddCommitment'} className="box no-border-bg-white"
                                                disabled={false}
                                                    onClick={ e => {
                                                    e.preventDefault();
                                                    setMonthlyDebtCommitItem(null);
                                                    setAddCommitmentPopup(true);
                                                }}>
                                                <span className="k-icon k-i-plus add-btn-blue"></span>&nbsp;
                                                <span className='add-btn-blue'>{'Add Commitment Details'}</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <FieldWrapper>
                                <CommitmentHistory data={monthlyDebtCommitList}
                                    isFromPreview={false} 
                                    onItemClick={(btnAction,indexNo,mdcItem)=>{
                                        // console.log('onCommitmentItemClick: ',btnAction,indexNo,mdcItem);
                                        if(btnAction==='EDIT') {
                                            setAddCommitmentPopup(true);
                                            setMonthlyDebtCommitItem(mdcItem);
                                            setMdcIndex(indexNo);
                                            return;
                                        }
                                        if(btnAction==='REMOVE') {
                                            let mdcList = [...monthlyDebtCommitList];
 
                                            mdcList.splice(indexNo,1);
                                            setMonthlyDebtCommitList(mdcList);
                                        }
                                    }}
                                />
                            </FieldWrapper>

                            {addCommitmentPopup &&
                            <AddCommitmentPopup popupValue={addCommitmentPopup} setTrigger={handleCommitmentPopupClose}
                                fProps={formRenderProps}
                                editedItem ={monthlyDebtCommitItem}
                                onClickAdd={handleAddCommitment} />
                            }

                            {/* {monthlyDebtCommitList.map((x,i) => {
                                return(
                                    <div key={i}>
                                        <div className="row around-xs inputPair elementVisible">
                                            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                                                <div className="box">
                                                    <FormComboBox id={'ddlLoanProdType'+i} 
                                                        name={'ddlLoanProdType'+i}
                                                        data={pData.loanProdTypeDDLList}
                                                        placeholder={'Select Product Type'}
                                                        textField={'label'}
                                                        required={false}
                                                        validator={reqDDLValidator}
                                                        disabled={false}
                                                        value={x.ddlLoanProdType}
                                                        onChange={e => handleDDLLoanProdType(e,i)} 
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                                                <div className='box'>
                                                    <FormComboBox id={'ddlNoOfBanks'+i} 
                                                        name={'ddlNoOfBanks'+i}
                                                        data={pData.noOfBanksDDLList}
                                                        placeholder={'Select No. of Banks'}
                                                        textField={'label'}
                                                        required={false}
                                                        validator={reqDDLValidator}
                                                        disabled={x.ddlLoanProdType === null? true:false}
                                                        value={x.ddlNoOfBank}
                                                        onChange={e => handleDDLNoOfBank(e,i)}  
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                                                <div className='box'>
                                                    <div className='wd-90-pert item-float-left'>
                                                        <FormNumericTextBox
                                                            id={'amount'+i}
                                                            name={'amount'+i}
                                                            format="c2"
                                                            placeholder="S$0"
                                                            min={0}
                                                            spinners={false}
                                                            validator={numericValidator}
                                                            value={x.amount}
                                                            disabled={x.ddlLoanProdType === null? true:false}
                                                            onChange={(event) => {
                                                                let nValue = event.target.value === '' ? '' : Number(event.target.value);
                                                                const list = [...monthlyDebtCommitList];
                                                                list[i].amount = nValue;
                                                                setMonthlyDebtCommitList(list);
                                                            }}
                                                        />
                                                        {(x.ddlLoanProdType !== null)&&
                                                        <div className='txtGray'>
                                                            {x.ddlLoanProdType.value === pData.overDraftCode?'Please key in facility limit':'Please key in monthly instalment'}
                                                        </div>
                                                        }
                                                    </div>
                                                    {(monthlyDebtCommitList.length >= 1)&&
                                                    <div className='wd-10-pert item-float-right'>
                                                        <span className="k-icon k-i-delete" style={{fontSize:'22px',padding:'10px 0 0 0'}} 
                                                            onClick={e => {
                                                                e.preventDefault();
                                                                
                                                                removeMonthlyDebitCommit(i);
                                                            }}              
                                                        /> 
                                                    </div>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                 )
                            })}
          
                            <div className="row around-xs inputPair elementVisible">
                                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                    <button id={'btnAddCommitment'} className="box no-border-bg-white"
                                        disabled={false}
                                        onClick={ e => {
                                            e.preventDefault();

                                            // console.log('AddCommitment',monthlyDebtCommitList)
                                            if(monthlyDebtCommitList.length > 0) {
                                                const l =monthlyDebtCommitList.length;
                                                const k =l-1;
                                                const kValue = monthlyDebtCommitList[k];
                                            
                                                if(kValue.ddlLoanProdType ===null || kValue.ddlNoOfBank === null || kValue.amount===null) {
                                                    showErrMsg(pData.error.noMonthlyDebts);
                                                    return;
                                                }
                                            }

                                            setMonthlyDebtCommitList([...monthlyDebtCommitList,{ddlLoanProdType:null,ddlNoOfBank:null,amount:null}])
                                        }}>
                                        <span className="k-icon k-i-plus add-btn-blue"></span>&nbsp;
                                        <span className='add-btn-blue'>{'Add Commitment'}</span>
                                    </button>
                                </div>
                            </div> */}

                            <div className="divgreylineCpf div-mrg" />
                            <FieldWrapper>
                                <Field component={FormTitleHybrid} id={'ft6'} name={pData.formTitle.ft6}/>
                            </FieldWrapper>

                            <div>
                                <div className="row around-xs inputPair elementVisible">
                                    <div className="col-xs-12 col-sm-5 col-md-5 col-lg-5">
                                        <div className='box'>
                                            {pData.label.annInterestExp}
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-sm-7 col-md-7 col-lg-7">
                                        <div className='wd-40-pert item-float-left'>
                                            <Field id={'latestAnnIntExpCurrencyCbo'} 
                                                name={'latestAnnIntExpCurrencyCbo'}
                                                component={FormComboBox}
                                                textField={'label'}
                                                data={latestAnnIntExpCurrencies}
                                                placeholder={'Please select'}
                                                validator={reqDDLValidator}
                                                filterable={true}
                                                onFilterChange={filterLatestAnnIntExpCurrencyCboChange}
                                            />
                                        </div>
                                        <div className='wd-60-pert item-float-left' style={{padding:'0 0 0 10px'}}>
                                            <Field component={FormNumericTextBox}
                                                id={'latestAnnIntExp'}
                                                name={'latestAnnIntExp'}
                                                placeholder={'Please enter interest expense'}
                                                validator={allowZeroNumericValidator}
                                                spinners={false} 
                                                format="n2"
                                                min={0}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row around-xs inputPair elementVisible">
                                    <div className="col-xs-12 col-sm-5 col-md-5 col-lg-5">
                                        <div className='box'>
                                            {pData.label.annDeprecationAmt}
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-sm-7 col-md-7 col-lg-7">
                                        <div className='wd-40-pert item-float-left'>
                                            <Field id={'latestAnnIntDepOrAmortCurrencyCbo'} 
                                                name={'latestAnnIntDepOrAmortCurrencyCbo'}
                                                component={FormComboBox}
                                                textField={'label'}
                                                data={latestAnnIntDepOrAmortCurrencies}
                                                placeholder={'Please select'}
                                                validator={reqDDLValidator}
                                                filterable={true}
                                                onFilterChange={filterLatestAnnIntDepOrAmortCurrencyCboChange}
                                            />
                                        </div>
                                        <div className='wd-60-pert item-float-left' style={{padding:'0 0 0 10px'}}>
                                            <Field component={FormNumericTextBox}
                                                id={'latestAnnIntDepOrAmort'}
                                                name={'latestAnnIntDepOrAmort'}
                                                placeholder={'Please enter amount'}
                                                validator={allowZeroNumericValidator}
                                                spinners={false} 
                                                format="n2"
                                                min={0}
                                            />
                                        </div>
                                    </div>
                                </div>
                                {(storage.getIsPureAIP() === 'true') &&
                                    <FieldWrapper>
                                        <div className='lbl-note-grey aip-otp-txt otp-note-margin'>
                                        {pData.label.footerNote}
                                        </div>
                                    </FieldWrapper>
                                }
                            </div>
                            
                        </fieldset>
                        <br/>
                    </FormContainer>
                    }

                    <FormContainer>
                        <div style={{paddingTop:'20px',paddingBottom:'20px'}}>
                            <div className="row around-xs inputPair elementVisible">
                                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                    <Button type={'submit'} className="k-button btn btnMargin btn-success btn-float-right">{config.btnName.Next}</Button>
                                    <Button type={'button'} style={{border:'1px solid #343a40'}} className="k-button btn btnMargin btn-back" onClick={handleBack}>{config.btnName.Back}</Button>
                                </div>
                            </div>                            
                        </div>
                    </FormContainer>  

               
                    <br/>
                </FormElement>
        )}></Form>
 
        <LoadingText show={isSearching} setShow={setIsSearching} label={'Please wait..'} />
        {isSaving && <Loading />}
        <CusToast className="popUpBox" trigger={isError} setTrigger={setIsError} label={errMsg} timer={timer}  /> 
    </div>
    )

}


export default PropertyDetailsAIP;